export var AmplitudeEventKeys;
(function (AmplitudeEventKeys) {
    AmplitudeEventKeys["ClickSlippingAwayReport"] = "CLICK-SLIPPING-AWAY-REPORT";
    AmplitudeEventKeys["ClickVisitorReport"] = "CLICK-VISITOR-REPORT";
    AmplitudeEventKeys["ClickChurnedReport"] = "CLICK-CHURN-REPORT";
})(AmplitudeEventKeys || (AmplitudeEventKeys = {}));
export var AmplitudeVariantValue;
(function (AmplitudeVariantValue) {
    AmplitudeVariantValue["OFF"] = "off";
    AmplitudeVariantValue["CONTROL"] = "control";
    AmplitudeVariantValue["A"] = "a";
    AmplitudeVariantValue["B"] = "b";
    AmplitudeVariantValue["C"] = "c";
})(AmplitudeVariantValue || (AmplitudeVariantValue = {}));
// Key needs to be lowercase only
export var AmplitudeFlagKey;
(function (AmplitudeFlagKey) {
    AmplitudeFlagKey["TaxDeductionMessaging"] = "tax-deduction-messaging";
    AmplitudeFlagKey["DonationFormCopyAbTest"] = "donation-form-copy-ab-test";
    AmplitudeFlagKey["TicketingFormButtonCopyAbTest"] = "ticketing-form-button-copy-ab-test";
    AmplitudeFlagKey["CheckboxAcknowledgingContribution"] = "checkbox-acknowledging-contribution-activation";
    AmplitudeFlagKey["EmptyStateExperiment"] = "empty-state-redirection";
    AmplitudeFlagKey["MigrateToStytch"] = "stytch";
    AmplitudeFlagKey["CommunicationStrategy"] = "communication-strategy";
    AmplitudeFlagKey["QaActions"] = "qaactions";
    AmplitudeFlagKey["DemotivateEmbeds"] = "demotivate-embeds";
    AmplitudeFlagKey["NpoStarterBanking"] = "npo-starter-banking";
    AmplitudeFlagKey["NpoStarterToDoList"] = "npo-starter-to-do-list";
    AmplitudeFlagKey["IsImportGmailActive"] = "is-gmail-import-active";
    AmplitudeFlagKey["IsImportMailchimpActive"] = "is-mailchimp-import-active";
    AmplitudeFlagKey["NewCopyContributionCanadaTip"] = "new-copy-contribution-canada-tip";
    AmplitudeFlagKey["LiveFormP2p"] = "live-form-p2p";
    AmplitudeFlagKey["AccurateBalanceForNextPayout"] = "accurate-balance-for-next-payout";
    AmplitudeFlagKey["AIAssistedFormCreationOnboarding"] = "ai-assisted-form-creation-onboarding";
    AmplitudeFlagKey["AIAssistedFormCreationExistingUser"] = "ai-assisted-form-creation-existing-user";
    AmplitudeFlagKey["LivePeerCredChip"] = "live-peer-cred-chip";
    AmplitudeFlagKey["LivePeerCredChipTicketsLeft"] = "live-peer-cred-chip-tickets-left";
    AmplitudeFlagKey["ImprovedStripeVerificationUS"] = "improved-stripe-verification-us";
    AmplitudeFlagKey["FormsUnsupportedBrowserRedirection"] = "forms-unsupported-browser-redirection";
    AmplitudeFlagKey["ShareZeffyExternallyDuringActivation"] = "share-zeffy-externally-during-activation";
    AmplitudeFlagKey["EasierDonorRefund"] = "easier-donor-refund";
    AmplitudeFlagKey["FormCtaCopy"] = "form-cta-copy";
    AmplitudeFlagKey["PostMail"] = "post-mail";
    AmplitudeFlagKey["CampaignPerformanceDashboard"] = "campaign-performance-dashboard";
    AmplitudeFlagKey["DelayedSignUp"] = "delayed-sign-up";
    AmplitudeFlagKey["CustomDomain"] = "custom-domain";
    AmplitudeFlagKey["QuestionFilterOnGuestList"] = "question-filter-on-guest-list";
})(AmplitudeFlagKey || (AmplitudeFlagKey = {}));
